import type { Installment, RecurringOffer } from 'models';

import type { NormalizedEntity, RootState } from 'reducers/types';

export const selectFirstOfferInstallments = (
  state: RootState,
): Installment[] | undefined => {
  const recurringOffers: NormalizedEntity<RecurringOffer> =
    state.entities.recurringOffers;
  const firstOfferId = recurringOffers.ids[0];
  if (!firstOfferId) {
    return undefined;
  }
  const firstOffer = recurringOffers.byId[firstOfferId];
  return firstOffer?.installments;
};
